import React from "react";

import styled from "@emotion/styled";
import { Box, Modal } from "@mui/material";

const StyledContainer = styled(Box)(({ theme, width, height }) => ({
  background: "#fff",

  // position: "absolute",
  // bottom: ({ bottom }) => bottom && bottom,
  // right: ({ right }) => right && right,

  color: "#000",
  //   paddingTop: "20px",
  //   paddingBottom: "20px",
  borderRadius: "10px",
  width: width && width,
  height: height && height,
}));

const CustomModal = ({
  open,
  onClose,
  modalFunc,
  Children,
  childrenProps,
  width,
  height,
  bottom,
  right,
}) => {
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <StyledContainer width={width} height={height}>
          {childrenProps ? <Children {...childrenProps} /> : <Children />}
        </StyledContainer>
      </Modal>
    </>
  );
};

export default CustomModal;

// const useStyles = makeStyles((theme) => ({
//   box: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "flex-end",
//     marginBottom: "10px",
//   },
//   closeIcon: {
//     padding: "0px",
//   },
//   container: {
//     background: "#fff",

//     // position: "absolute",
//     // bottom: ({ bottom }) => bottom && bottom,
//     // right: ({ right }) => right && right,

//     color: "#000",
//     paddingTop: "20px",
//     paddingBottom: "20px",
//     borderRadius: "10px",
//     width: ({ width }) => width && width,
//     height: ({ height }) => height && height,
//     // "@media(max-width:550px)": {},
//   },
//   dialog: {
//     // background: "#fff",
//     background: "transparent",
//     // border: "1px solid rgba(230, 231, 233, 0.1)",
//     backdropFilter: "transparent",
//     // minWidth: 400,
//     // width: 550,
//   },
//   dialogPosition: {
//     // position: "absolute",
//     // transform: "translateY(60vh)",
//     // "@media(max-width:550px)": {
//     //   transform: "translateY(50%)",
//     // },
//   },
//   infoImg: {
//     marginBottom: "24px",
//   },
//   infoText: {
//     textAlign: "center",
//     marginBottom: "26px",
//     width: "80%",
//     fontWeight: 600,
//   },
//   headerText: {
//     textAlign: "center",
//     marginBottom: "5px",
//     width: "90%",
//     fontWeight: 600,
//   },
//   centerAlign: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//   },
//   spinner: {
//     color: "#FA0339",
//     marginBottom: "34px",
//   },
// }));
